const RangeValueHook = {
  mounted() {
    this.targetSelector = this.el.dataset.target;
    this.targetElement = document.querySelector(this.targetSelector);

    if (!this.targetElement) {
      console.error("RangeValueHook: Target element not found", this.targetSelector);
      return;
    }

    // Initial display
    this.targetElement.textContent = this.el.value;

    // Update display on input
    this.el.addEventListener('input', (e) => {
      if (this.targetElement) {
        this.targetElement.textContent = e.target.value;
      }
    });
  },
  // Optional: Handle updates if LV changes the input's value externally
  updated() {
     if (this.targetElement && this.el.value !== this.targetElement.textContent) {
       this.targetElement.textContent = this.el.value;
     }
  }
};

export default RangeValueHook;
